import { FuelTableContainer } from 'pages/FuelManagement/FuelManagement.styled'
import styled from 'styled-components'
import { Box } from 'styling/GlobalStyles'

export const AccommodationRoomsTableContainer = styled(FuelTableContainer)`
  width: 100%;
`

export const AccommodationNotificationContainer = styled(Box)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  transition: 0.2s ease;

  :hover {
    box-shadow: 0px 0px 8px 0px hsba(36, 100%, 100%, 0.5);
    outline: 1px solid #ff9900;
  }
`

export const CampContainer = styled.div<{ active?: boolean }>`
  ${(props) => props.theme.container};
  width: 100%;
  height: ${(props) => (props.active ? 'fit-content' : '94px')};
  transition: 0.2s ease;
  cursor: pointer;
  overflow: ${(props) => (props.active ? 'visible' : 'hidden')};
`

export const CampOverviewContainer = styled.div`
  ${(props) => props.theme.content};
  height: 94px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  border-radius: 12px;
`

export const BlockContainer = styled.div`
  padding: 1rem;
  width: 100%;
  display: grid;
  height: max-content;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
`

export const Block = styled.div`
  ${(props) => props.theme.content};
  padding: 1rem;
  height: 250px;
`

export const AvailabilityIndicator = styled.div<{ color: string; percentage: number }>`
  width: 100%;
  height: 8px;
  border-radius: 100vw;
  background-color: #333333;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: ${(props) => props.percentage}%;
    border-radius: 100vw;
    background-color: ${(props) => props.color || '#24D07B'};
  }
`

export const BlockStatusesContainer = styled.div<{ fr?: string }>`
  width: 100%;
  display: grid;
  height: max-content;
  grid-template-columns: repeat(${(props) => props.fr || 2}, 1fr);
  gap: 1rem;
`

export const ColoredSquare = styled.div<{ color: string; width?: string }>`
  width: ${(props) => props.width || '32px'};
  aspect-ratio: 1/1;
  background-color: ${(props) => props.color};
  border-radius: 10px;
  display: grid;
  place-items: center;
`

export const BedContainer = styled.div`
  ${(props) => props.theme.content};
  height: fit-content;
  padding: 1rem;
`

export const BedMiddleSection = styled.div<{ borderColor?: string }>`
  ${(props) => props.theme.content};
  width: 100%;
  border: 1px solid ${(props) => props.borderColor || '#333333'};
  border-radius: 10px;
  padding: 0.5rem;
  margin: 1rem 0;
  display: flex;
  flex-direction: column;
`

export const BedFooter = styled.div`
  ${(props) => props.theme.content};
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1rem;
`
export const StepNumber = styled.div<{ active?: boolean }>`
  width: 32px;
  height: 32px;
  border-radius: 100%;
  ${(props) => props.active && 'border: 1px solid #ff9900;'}
  background: #2c2a29;
  display: grid;
  place-items: center;
  color: #ff9900;
  font-size: 16px;
`

export const Container = styled.div`
  background: rgba(34, 32, 32, 0.5);
  width: 100%;
  border: 1px solid rgba(34, 32, 32, 0.3);
  border-radius: 10px;
`

export const ContainerHeader = styled.div<{ padding?: boolean }>`
  background: rgba(42, 42, 42, 0.5);
  border-bottom: 1px solid rgba(42, 42, 42, 0.3);
  border-radius: 0px 16px 0px 0px;
  width: 100%;
  height: 50px;
  display: flex;
  ${(props) => props.padding && 'padding:1rem; height:auto;'}
`

export const ContainerContent = styled.div<{ noHeader?: boolean; gap?: string }>`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  margin-top: ${(props) => (props.noHeader ? '0rem' : '1rem')};
  height: calc(100% - 50px - 1rem);
  gap: ${(props) => props.gap || '0rem'};
`

export const HeaderButton = styled.div<{ active?: boolean }>`
  width: 100%;
  display: grid;
  place-items: center;
  cursor: pointer;
  ${(props) => props.active && 'border-bottom: 1px solid #ff9900;'}
  color:${(props) => props.theme.textColor};
  font-size: 16px;
`

export const IconContainer = styled.div`
  width: 64px;
  height: 64px;
  display: grid;
  place-items: center;
  background-color: #6a6a6a;
  border-radius: 100%;
`

export const SelectedEmployeeImage = styled.div`
  min-width: 40px;
  height: 40px;
  border-radius: 100%;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
  }
`

export const PersonChip = styled.div<{ type: 'Employee' | 'Guest' }>`
  width: 85px;
  height: 22px;
  border-radius: 5px;
  display: grid;
  place-items: center;
  background-color: ${(props) => (props.type === 'Employee' ? '#2B7FFF1A' : '#AD46FF1A')};
  border: 1px solid ${(props) => (props.type === 'Employee' ? '#00A6FF' : '#B16FE6')};
  color: ${(props) => (props.type === 'Employee' ? '#00A6FF' : '#B16FE6')};
  font-size: 12px;
`

export const BedStatusChip = styled.div<{ status: 'Available' | 'Dirty' }>`
  min-width: 85px;
  height: 30px;
  border-radius: 50px;
  padding: 0 12px;
  display: grid;
  place-items: center;
  border: 1px solid ${(props) => (props.status === 'Available' ? '#24D07B' : '#F4D03F')};
  background-color: ${(props) => (props.status === 'Available' ? '#24D07B1A' : '#FF99001A')};
  color: ${(props) => (props.status === 'Available' ? '#24D07B' : '#F4D03F')};
  font-size: 12px;
`

export const ConatinerScroll = styled.div`
  overflow: auto;
`

export const GuestCardsContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  margin-top: 2rem;
`

export const GuestCard = styled(Box)<{ borderColor?: string }>`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  ${(props) => props.borderColor && `border:1px solid ${props.borderColor}`}
`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-radius: 10px;
  overflow: hidden;
`

export const Thead = styled.thead``

export const Thr = styled.tr`
  background-color: rgba(34, 32, 32, 0.8);
`

export const Tbody = styled.tbody``

export const Tr = styled.tr`
  &:nth-child(odd) {
    background-color: rgba(34, 32, 32, 0.3);
  }

  /* Drugi red (parni) */
  &:nth-child(even) {
    background-color: rgba(34, 32, 32, 0.5);
  }

  &:hover {
    background-color: rgba(255, 255, 255, 0.05);
    transition: background-color 0.2s ease;
  }
`

export const Th = styled.th`
  font-size: 14px;
  color: #b0b0b0;
  height: 48px;
  text-align: start;
  padding: 16px;
`

export const Td = styled.td`
  padding: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  height: 68px;
`

export const AddAccommodationModalWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: grid;
  place-items: center;
  z-index: 99999;
  /* Rectangle 11 */
  background: rgba(34, 32, 32, 0.3);
  backdrop-filter: blur(13.2px);
`

export const AddAccommodationModalContainer = styled.div`
  height: 750px;
  border-radius: 16px;
  display: flex;
  overflow: hidden;
`

export const AddAccommodationSteps = styled.div`
  padding: 2rem;
  background-color: #ff9900;
  width: 292px;
  display: flex;
  flex-direction: column;
`

export const AccommodationStep = styled.div<{ active?: boolean }>`
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  color: ${(props) => (props.active ? '#ff9900' : '#B0B0B0')};
  background-color: white;
  border-radius: 100px;
  font-weight: bold;
`

export const AddAccommodationModalContnet = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 698px;
  padding: 2rem;
  background: rgba(60, 60, 60, 0.5);
  box-shadow: 0px 25px 50px -12px rgba(0, 0, 0, 0.25);
`

export const AddAccommodationModalContentInputs = styled(Box)``

export const AccomodationBlockReveiw = styled.div`
  position: relative;
  padding-left: 1rem;
  display: flex;
  gap: 1rem;

  &::after {
    height: 100%;
    position: absolute;
    content: '';
    width: 3px;
    top: 0;
    left: 0;
    border-radius: 50px;
    background-color: #ff9900;
  }
`
